import axios from "axios";
import { urlBaseHall } from './../../config/index';

export default async function getHallTokenByEventId(
  eventId = '',
) {
  try {
    const _config = {
      url: `${urlBaseHall}/firebase/hallauthenticationbyeventidv2?eventId=${eventId}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const _res = await axios(_config);
    return _res.data;

  } catch (error) {
    console.log('Error getHallTokenByEventId', error);
    throw error;
  }
}
